import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Give the Gift of Stress-Free Ski & Snowboard Travel | ShipSkis',
  description:
    'Perfect for birthdays, holidays, or just because, ShipSkis gift cards are the ' +
    'ultimate gift for skiers and snowboarders on the go.',
  alternates: {
    canonical: 'https://www.shipskis.com/gift-cards',
  },
}

export default metadata
